// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QfEB9","colBig":"styles_colBig__2HLzF","colSmall":"styles_colSmall__w4327"};